export enum ErrorMessage {
  // エラーメッセージ
  GRAPH_QL_TIME_OUT = 'Execution timed out.',

  DATA_GET_ERROR = 'マスター情報の取得に失敗しました。',

  REGISTR_FAILED = '登録に失敗しました。',

  DELETE_FAILED = '削除に失敗しました。',

  REGISTR_FAILED_PART = '一部の登録処理が失敗しました。',

  INPUT_ERROR = '入力エラーがあります。',
}

export enum InfoMessage {
  // 警告メッセージ
  CHECK_REQUIRED = '未入力の必須項目があります。',

  CHECK_CODE_REQUIRED = 'コードを入力してください',

  REGISTR_DUPLICATION = 'コードが重複しています。',

  NOT_EXIST_HIN_INFO = '品名管理情報が登録されていません。',

  NOT_EXIST_USER = 'ユーザー情報が登録されていません。',

  ONLY_REGISTERED_DATA_EXPORT = '新規データは出力できません。<br/>登録をおこなってください。',

  // 確認メッセージ
  CONFIRM_REGISTR = '登録します。よろしいですか？',

  CONFIRM_REMOVE = '削除します。よろしいですか？',

  // 結果メッセージ
  REGISTR_SUCCESS = '登録が完了しました。',

  SELECT_PRIMARY_STORE = '一次店を選択してください',

  CONFIRM_START_MAINTAINCE = 'メンテナンスモードに変更しますか',

  CONFIRM_STOP_MAINTAINCE = 'メンテナンスモードを解除しますか',

  NOT_RE_QUOTE = '新規見積のため再見積できません',

  CONFIRM_QUOTE = '入力途中の見積は保存されません。よろしいですか？',

  CAN_NOT_DELETE_QUOTE = '新規見積のため削除できません',

  REQUIRE_SELECT_PRIMARY_STORE = '一次店を選択してください',
}

export enum InfoWord {
  // 単語
  YES = 'はい',
  NO = 'いいえ',
  OK = 'Ok',

  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',

  DELETE_ERROR = 'Delete Error',
  UPDATE_ERROR = 'Update Error',
  INSERT_ERROR = 'Insert Error',
}
